{
  "versions": {
    "@sentry/browser": "4.6.6",
    "@wix/bi-logger-sanitizer": "1.1.3",
    "@wix/fedops-logger": "3.0.125",
    "@wix/fed-sec-utils": "1.0.492",
    "@wix/js-platform-apps-configuration": "1.0.526",
    "@wix/platform-editor-sdk": "^1.3978.0",
    "@wix/promote-analytics-adapter": "1.0.484",
    "@wix/santa-animations": "1.496.0",
    "@wix/santa-browser-detection": "1.448.0",
    "@wix/santa-bundle": "1.1062.0",
    "@wix/santa-components": "1.1984.0",
    "@wix/santa-core-utils": "1.2722.0",
    "@wix/santa-ds-libs": "^1.0.0",
    "@wix/santa-data-fixer": "1.1640.0",
    "@wix/santa-external-modules": "1.644.0",
    "@wix/santa-galleries": "1.1191.0",
    "@wix/santa-host-platform-services": "1.737.0",
    "@wix/santa-image-utils": "1.969.0",
    "@wix/santa-main-r": "1.1643.0",
    "@wix/santa-mobile-core": "1.1270.0",
    "@wix/santa-multilingual": "1.1157.0",
    "@wix/santa-platform-utils": "1.1429.0",
    "@wix/santa-shared-schemas": "1.594.0",
    "@wix/santa-site-auth-module": "1.0.16",
    "@wix/santa-skin-utils": "1.1686.0",
    "@wix/stylable-santa-flatten": "3.0.56",
    "@wix/viewer-platform-worker": "1.0.3667",
    "@wix/wix-base-ui": "2.778.0",
    "@wix/wix-code-backend-testkit": "1.17.0",
    "@wix/wix-code-platform": "1.1097.69",
    "@wix/wix-dom-sanitizer": "1.786.0",
    "@wix/wix-fullstory-loader": "1.404.0",
    "@wix/wix-json-schema-utils": "1.429.0",
    "@wix/wix-ui-santa": "2.0.358",
    "@wixc3/stylable-panel-drivers": "2.3.2",
    "ag-grid": "6.4.2",
    "atob": "2.1.2",
    "blueimp-md5": "2.18.0",
    "color": "0.11.4",
    "create-react-class": "15.7.0",
    "data-capsule": "1.0.83",
    "date-fns": "1.30.1",
    "gsap": "2.1.3",
    "hammerjs": "2.0.8",
    "hls.js": "0.8.9",
    "image-client-api": "1.4060.0",
    "immutable": "3.8.2",
    "jsdom": "9.12.0",
    "lodash": "4.17.21",
    "mobx": "3.3.3",
    "mobx-react": "4.2.2",
    "mousetrap": "1.6.5",
    "node-fetch": "2.6.1",
    "pm-rpc": "3.2.7",
    "prop-types": "15.7.2",
    "raven-js": "3.27.2",
    "react": "16.14.0",
    "react-dom": "16.14.0",
    "react-dom-factories": "1.0.2",
    "seedrandom": "3.0.5",
    "socket.io-client": "2.4.0",
    "soundmanager2": "2.97.20150601-a",
    "speakingurl": "7.0.0",
    "swfobject": "2.2.1",
    "wspy": "3.0.19",
    "xss": "0.2.18",
    "zepto": "1.2.0",
    "tweenmax": "1.19.0"
  },
  "bundles": [
    "displayer",
    "backgroundCommon",
    "site-widgets",
    "formCommon",
    "textCommon",
    "socialCommon",
    "thirdPartyAnalytics",
    "galleriesCommon",
    "buttonCommon",
    "compDesignUtils",
    "imageZoom",
    "render",
    "skinExports",
    "compUtils",
    "hostLibs",
    "dataFixer"
  ],
  "manifest": {}
}
